import React, { useState, useEffect, useRef } from 'react';
import qs from 'querystring';
import ApolloClient from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { HttpLink } from 'apollo-link-http';
import Helmet from 'react-helmet';
import { Query, ApolloProvider } from 'react-apollo';
import { makeStyles, useTheme } from '@material-ui/styles';
import Alert from '@material-ui/lab/Alert';
import Container from '@material-ui/core/Container';
import Spin from 'components/common/Spin';
import { GET_PRODUCT_BY_PLAN_ID } from 'graphql/products';
import withConfirm from '../../hooks/withConfirm';
import CohortCheckout from './CohortCheckout';
import SoloCheckout from './SoloCheckout';
import Checkout from './Checkout';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%',
    overflow: 'auto',
    backgroundColor: 'white',
    paddingBottom: theme.spacing(6),
  },
}));

const httpLink = new HttpLink({
  uri: process.env.REACT_APP_HGE_ENDPOINT,
});

const cache = new InMemoryCache({});
const client = new ApolloClient({
  link: httpLink,
  cache,
});

const CheckoutPage = ({ history, location, confirm }) => {
  const classes = useStyles();
  const query = qs.parse(location.search.substr(1));
  const rootRef = useRef();

  useEffect(() => {
    if (window.Intercom) {
      window.Intercom('boot', { app_id: 'xkovkvvi' });
    }

    return () => {
      window.Intercom('shutdown');
    };
  }, []);

  if (!query.plan) {
    return <Alert color="error">No product selected.</Alert>;
  }

  return (
    <ApolloProvider client={client}>
      <div className={classes.root} ref={rootRef}>
        <Container>
          <Helmet title="Checkout" />
          <Query
            query={GET_PRODUCT_BY_PLAN_ID}
            variables={{ planId: query.plan }}
          >
            {({ data, loading, error }) => {
              if (error) {
                return <Alert color="error">{error.message}</Alert>;
              } else if (loading) {
                return <Spin spinning linear />;
              }
              const product = data.products[0];
              if (!product) {
                return <Alert color="error">Product not found</Alert>;
              }
              const { product_type } = product;
              if (product_type === 'cohort') {
                return (
                  <CohortCheckout
                    product={product}
                    history={history}
                    location={location}
                    confirm={confirm}
                  />
                );
              } else if (product_type === 'solo') {
                return (
                  <SoloCheckout
                    product={product}
                    history={history}
                    location={location}
                    confirm={confirm}
                  />
                );
              } else if (product_type === 'cohort') {
                return (
                  <SoloCheckout
                    product={product}
                    history={history}
                    location={location}
                    confirm={confirm}
                  />
                );
              }
              return (
                <Checkout
                  product={product}
                  history={history}
                  location={location}
                  confirm={confirm}
                />
              );
            }}
          </Query>
        </Container>
      </div>
    </ApolloProvider>
  );
};

export default withConfirm(CheckoutPage);
